//import React, { useState, useEffect } from 'react';
import React, { useState, useEffect, useRef } from 'react';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, TextField, } from '@mui/material';
//import { AccountCircle, ImportContacts, ExitToApp } from '@mui/icons-material';
import { AccountCircle, Search, Public } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
//import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//import i18n from '../i18n';
import { decryptDiscussionFields } from '../services/signalGroupCrypto';


const flagByLang = {
  fr: '🇫🇷',
  en: '🇬🇧',
  de: '🇩🇪',
  es: '🇪🇸',
  it: '🇮🇹',
  nl: '🇳🇱',
  sv: '🇸🇪',
  fi: '🇫🇮',
  pl: '🇵🇱',
  ro: '🇷🇴',
  el: '🇬🇷',
  da: '🇩🇰',
  no: '🇳🇴',
  cs: '🇨🇿',
  uk: '🇺🇦',
  pt: '🇵🇹',
  hu: '🇭🇺',
  sk: '🇸🇰',
  hr: '🇭🇷',
  lt: '🇱🇹',
  et: '🇪🇪',
  lv: '🇱🇻',
  bg: '🇧🇬',
  sl: '🇸🇮',
  sr: '🇷🇸',
  is: '🇮🇸',
  ar: 'ع',
  mt: '🇲🇹',
};

const MenuComponent = ({ socket, onLogout, selectedDiscussion, setSelectedDiscussion, startVideoCall, setCallInProgress, callInProgress, prompt }) => {

const [decryptedSelectedTitle, setDecryptedSelectedTitle] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
const location = useLocation();

  const [openSearch, setOpenSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

// Déterminer si on est sur une autre page que "/"
  const isMainPage = location.pathname === "/";
const isPublicPage = location.pathname === "/public";
// Fonction de retour adaptée au contexte
  const handleBack = () => {
    if ((isMainPage || isPublicPage) && selectedDiscussion) {
      // Cas 1 : discussion ouverte -> retour à la liste
      setSelectedDiscussion(null);
    } else {
      // Cas 2 : autre page -> retour navigation
      navigate(-1);
    }
  };

const menuIconStyle = {
  fontSize: '20px',
  paddingRight: '10px',
  color: 'currentColor', // hérite de la couleur du MenuItem parent
};

const { t, i18n } = useTranslation();
const currentLang = i18n.language;
const currentFlag = flagByLang[currentLang] || '🏳️';

 const handleSearchOpen = () => setOpenSearch(true);
  const handleSearchClose = () => setOpenSearch(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setOpenSearch(false);
    navigate(`/public?search=${encodeURIComponent(searchQuery)}`);
  };



const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const token = localStorage.getItem('token');
//const title = "Clavardage";
const title = t('menu.titre');

useEffect(() => {
  if (!selectedDiscussion) return;
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.id;
  if (!userId) return;

  (async () => {
    const { title } = await decryptDiscussionFields(selectedDiscussion, socket, userId);
    setDecryptedSelectedTitle(title);
  })();
}, [selectedDiscussion]);

useEffect(() => {
  if (!socket) return;

  const handleStatus = (data) => {
    //console.log("📡 userStatusChanged :", data);
  };

  socket.on("userStatusChanged", handleStatus);
  return () => socket.off("userStatusChanged", handleStatus);
}, [socket]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleProfile = () => {
    navigate('/profile');
    handleMenuClose();
  };

const handleAccueil = () => {
    navigate('/');
    handleMenuClose();
setSelectedDiscussion(null);
setCallInProgress(false);
  };

const handleAbonnement = () => {
    navigate('/abonnements');
    handleMenuClose();
setSelectedDiscussion(null);
setCallInProgress(false);
  };


  const handleImportContacts = () => {
    navigate('/ImportContacts');
    handleMenuClose();
  };

 const handleCreateContact = () => {
    navigate('/CreateContact');
    handleMenuClose();
  };

 

 const handleInfos = () => {
    navigate('/Infos');
    handleMenuClose();
  };

const handleParametres = () => {
    navigate('/Parametres');
    handleMenuClose();
  };

const handleParametresLangue = () => {
  if (location.pathname === '/ParametresLangue') {
    navigate(-1); // ← déjà sur la page → on revient en arrière
  } else {
    navigate('/ParametresLangue');
  }
  handleMenuClose();
};

const handlePublic = () => {
if (location.pathname === '/public') {
    navigate(-1); // ← déjà sur la page → on revient en arrière
  } else {
    navigate('/public');
  }

    handleMenuClose();
setSelectedDiscussion(null);
setCallInProgress(false);
  };


  const handleLogout = () => {
    // Add your logout logic here
	onLogout(); 

    
    handleMenuClose();
  };

 const navigateToProfile = (creatorId) => {
    navigate(`/profile/${creatorId}`);
  };


 
  return (
    <AppBar className="AppBar" position="static"  style={{ width: '100%', boxShadow: 'none' }}>
      <Toolbar >

{(selectedDiscussion || !isMainPage) && (
  <IconButton edge="start" color="inherit" onClick={handleBack}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </IconButton>
)}


         {/* Titre générique quand aucune discussion n’est ouverte */}

      <Typography
  variant="h6"
  component="div"
  sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 1 }}
  onClick={!selectedDiscussion ? handleAccueil : undefined}
>
  {!selectedDiscussion ? (
    title
  ) : (
    <>
      <img
        src={
          selectedDiscussion.creator?.profileImage
            ? `${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${selectedDiscussion.creator._id}?token=${token}&type=image&thumb=true&profile=true&t=${selectedDiscussion.creator.profileImageUpdatedAt}`
            : `${API_URL}/uploads/default-profile.png`
        }
        alt="Créateur"
        style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          objectFit: 'cover',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          e.stopPropagation();
if (location.pathname === `/profile/${selectedDiscussion.creator._id}`) {
    navigate(-1); // ← déjà sur la page → on revient en arrière
  } else {
    navigate(`/profile/${selectedDiscussion.creator._id}`);
  }
  handleMenuClose();
         // navigate(`/profile/${selectedDiscussion.creator._id}`);
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span style={{ fontWeight: 'bold' }}>{selectedDiscussion.creator?.username}</span>
        <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>{decryptedSelectedTitle}</span>
      </div>
    </>
  )}
</Typography>

{/* ✅ Icône Appel Vidéo : si discussion affichée et ≥ 2 participants */}
  {selectedDiscussion && selectedDiscussion.participants?.length > 1 && !selectedDiscussion.isPublic && (
  <IconButton
    edge="end"
    color="inherit"
    aria-label="video call"
    onClick={async () => {
      if (callInProgress) return; // ← pas d'action si appel en cours
      const { confirm } = prompt;
      const confirmVideo = await confirm(t('discussion.alertvideo'));
      if (confirmVideo) {
        startVideoCall(selectedDiscussion._id);
      }
    }}
    title={callInProgress ? t('discussion.call_in_progress') : t('discussion.videocall')}
    style={{
      marginRight: '10px',
      animation: callInProgress ? 'pulse 1s infinite' : 'none',
    }}
  >
    <i
      className={callInProgress ? 'ti ti-video' : 'ti ti-video'}
      style={{
        fontSize: '22px',
        color: callInProgress ? 'lightgreen' : '#ffffff',
        transition: 'color 0.3s ease',
      }}
      aria-hidden="true"
    />
  </IconButton>
)}

	{/* ✅ Drapeau de langue */}
    	<Typography variant="h6" component="div" sx={{ mr: 1 }} onClick={handleParametresLangue}>
      	{currentFlag}
   	</Typography>
	
	{/* 🌍 Icône "Public / Groupes" */}
      <IconButton color="inherit"  onClick={handlePublic}  title="Groupes publics">
        <Public />
      </IconButton>

        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={handleMenuOpen}
        >
       <i className="ti ti-menu-2" style={{ fontSize: '22px' }} aria-hidden="true" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
 
	  <MenuItem className="MenuItem" onClick={handleAccueil}>
  <i className="ti ti-message-2" style={menuIconStyle} aria-hidden="true" />
  {t('menu.home')}
</MenuItem>

<MenuItem className="MenuItem" onClick={handleProfile}>
  <i className="ti ti-user-circle" style={menuIconStyle} aria-hidden="true" />
  {t('menu.infos')}
</MenuItem>

{isMobile && (
  <MenuItem className="MenuItem" onClick={handleImportContacts}>
    <i className="ti ti-address-book" style={menuIconStyle} aria-hidden="true" />
    {t('menu.contact')}
  </MenuItem>
)}

<MenuItem className="MenuItem" onClick={handleCreateContact}>
  <i className="ti ti-user-plus" style={menuIconStyle} aria-hidden="true" />
  {t('menu.createcontact')}
</MenuItem>

<MenuItem className="MenuItem" onClick={handleParametres}>
  <i className="ti ti-settings" style={menuIconStyle} aria-hidden="true" />
  {t('menu.settings')}
</MenuItem>

<MenuItem className="MenuItem" onClick={handleInfos}>
  <i className="ti ti-info-circle" style={menuIconStyle} aria-hidden="true" />
  {t('menu.utilisation')}
</MenuItem>

<MenuItem className="MenuItem" onClick={handleLogout}>
  <i className="ti ti-logout" style={menuIconStyle} aria-hidden="true" />
  {t('menu.logout')}
</MenuItem>

        </Menu>
      </Toolbar>

    </AppBar>
  );
};

export default MenuComponent;
